import { render, staticRenderFns } from "./admin.vue?vue&type=template&id=2519297c&scoped=true"
import script from "./admin.vue?vue&type=script&lang=ts"
export * from "./admin.vue?vue&type=script&lang=ts"
import style0 from "./admin.vue?vue&type=style&index=0&id=2519297c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2519297c",
  null
  
)

export default component.exports